import { CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { customerDetailsStore } from '@store/customers/customerDetails';
import { formatAmount } from '@utils/utils';
import StatusBadge from '@views/creditApplications/components/ui/StatusBadge';
import { CreditApplicationsRoute } from '@views/creditApplications';
import { useNavigate } from '@solidjs/router';
import { DateTime } from 'luxon';
import { For, Show } from 'solid-js';

const formatDate = (value: string | null | undefined) => {
  if (!value) return '—';
  const dt = DateTime.fromISO(value);
  return dt.isValid ? dt.toFormat('MM/dd/yyyy') : '—';
};

const GeneralCreditApplications = () => {
  const navigate = useNavigate();
  const applications = () => customerDetailsStore.customer.creditApplications;

  return (
    <Show when={applications().length > 0}>
      <CollapsibleCard startTitle="Credit Applications" class="mb-2">
        <div
          style={{
            height: 'auto',
            'max-height': '350px',
            'overflow-y': 'auto',
          }}
        >
          <For each={applications()}>
            {(application) => (
              <button
                type="button"
                class="w-full text-left rounded-md border border-slate-200 bg-slate-50 hover:bg-slate-100 p-2 mb-2 transition-colors cursor-pointer"
                onClick={() =>
                  navigate(`${CreditApplicationsRoute.path}/${application.id}`)
                }
              >
                <div class="flex flex-col space-y-1 text-sm">
                  <div class="flex items-center gap-2">
                    <span class="font-semibold truncate">
                      {application.legalCompanyName}
                    </span>
                    <span class="ml-auto shrink-0">
                      <StatusBadge status={application.status} size="compact" />
                    </span>
                  </div>

                  <div class="flex">
                    <span class="font-semibold">Requested Limit</span>
                    <span class="ml-auto">
                      {formatAmount(application.requestedLimit)}
                    </span>
                  </div>

                  <div class="flex">
                    <span class="font-semibold">Approved Limit</span>
                    <span class="ml-auto">
                      {formatAmount(application.approvedLimit)}
                    </span>
                  </div>

                  <div class="flex">
                    <span class="font-semibold">Submitted</span>
                    <span class="ml-auto">
                      {formatDate(application.submittedDateUtc)}
                    </span>
                  </div>
                </div>
              </button>
            )}
          </For>
        </div>
      </CollapsibleCard>
    </Show>
  );
};

export default GeneralCreditApplications;
